import { VisuallyHidden as Primitive } from "radix-ui";
import type { ReactNode } from "react";

/** § Primitives, VisuallyHidden: content for assistive technology only. It is Radix UI's VisuallyHidden (MIT) as it comes; having no visual, it has no Spectrum UI or shadcn/ui source to take (2026-09-18, slice (f)). */
export function VisuallyHidden({ children }: { readonly children: ReactNode }) {
  return <Primitive.Root>{children}</Primitive.Root>;
}
